import {removeWhiteSpace, getSimilarityScore} from 'helpers/string'
import {sortByKeyReverse} from 'helpers/sorting'
import {get} from 'lodash'

const getSearchableFieldValue = (value) => removeWhiteSpace(value.toLowerCase())

export const findField = (name, allFields, currentFields, keyMatch = false) => {
  if (name && name.length > 0) {
    const searchFor = getSearchableFieldValue(name)

    const scoredFields = allFields
        .map(field => ({
          ...field,
          score: getFieldScore(field, searchFor, keyMatch, currentFields),
        }))
        .filter(field => field.score > 0)
        .sort((fieldA, fieldB) => sortByKeyReverse(fieldA, fieldB, 'score'))

    return get(scoredFields, [0, 'key'], null)
  }
}

const fieldIsAllocated = (field, currentFields) => {
  return currentFields.some(f => f === field.key)
}

export const getFieldScore = (field, searchFor, keyMatch, currentFields) => {
  if (fieldIsAllocated(field, currentFields)) return 0

  const fieldValue = getSearchableFieldValue(keyMatch ? field.key : field.label || field.alias)

  const fieldValueInSearchFor = searchFor.indexOf(fieldValue)
  const searchForInFieldValue = fieldValue.indexOf(searchFor)

  return (fieldValueInSearchFor < 0 && searchForInFieldValue < 0)
    ? 0
    : getSimilarityScore(fieldValue, searchFor)
}

